export default {
  LANDING: '/landing',
  LOGIN: '/login',
  INELIGIBLE: '/ineligible',
};
